import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';
import '../styles/MobileNavBar.css';

/**
 * Mobile bottom navigation bar component
 * Shows different navigation items based on user role
 */
const MobileNavBar = () => {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  
  // Check if current path matches
  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };
  
  // Get navigation items based on user role
  const getNavItems = () => {
    const baseItems = [
      { path: '/dashboard', label: 'Dashboard', icon: '📊' }
    ];

    if (!user) return baseItems;

    // Logout item - displays as Profile but logs out when clicked
    const logoutItem = { 
      path: '#', 
      label: 'Logout', 
      icon: '👤',
      onClick: () => {
        if (window.confirm('Are you sure you want to log out?')) {
          logout();
        }
      }
    };

    // Common items for all roles (to conserve mobile nav space)
    const commonItems = [
      ...baseItems,
      logoutItem
    ];

    switch (user.role) {
      case 'student':
        return [
          ...baseItems,
          { path: '/assignments/student', label: 'Assignments', icon: '📝' },
          { path: '/messages', label: 'Messages', icon: '✉️' },
          logoutItem
        ];

      case 'teacher':
        return [
          ...baseItems,
          { path: '/messages', label: 'Messages', icon: '✉️' },
          { path: '/settings', label: 'Settings', icon: '⚙️' }
        ];

      case 'parent':
        return [
          ...baseItems,
          { path: '/messages', label: 'Messages', icon: '✉️' },
          { path: '/settings', label: 'Settings', icon: '⚙️' }
        ];

      case 'admin':
        return [
          ...baseItems,
          { path: '/users', label: 'Users', icon: '👥' },
          { path: '/classes', label: 'Classes', icon: '🏫' },
          { path: '/messages', label: 'Messages', icon: '✉️' },
          { path: '/settings', label: 'Settings', icon: '⚙️' }
        ];

      case 'super_admin':
        return [
          ...baseItems,
          { path: '/centers', label: 'Centers', icon: '🏢' },
          { path: '/users', label: 'Users', icon: '👥' },
          { path: '/settings', label: 'Settings', icon: '⚙️' },
          { path: '/profile', label: 'Profile', icon: '👤' }
        ];

      default:
        return commonItems;
    }
  };
  
  // Get navigation items for current user
  const navItems = getNavItems();
  
  // Only show on mobile devices
  if (window.innerWidth > 768) {
    return null;
  }
  
  // The onClick handlers are now directly in the Link component and the logoutItem

  return (
    <div className="mobile-navbar">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`mobile-nav-item ${isActive(item.path) ? 'active' : ''}`}
          onClick={(e) => {
            if (item.path === '#' || item.onClick) {
              e.preventDefault(); // Prevent navigation
              if (item.onClick) {
                item.onClick();
              }
            }
          }}
        >
          <div className="mobile-nav-icon">{item.icon}</div>
          <div className="mobile-nav-label">{item.label}</div>
        </Link>
      ))}
    </div>
  );
};

export default MobileNavBar;